import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { EditPromotionPage } from "@/features/ventes/components/tarifs/EditPromotionPage";
import { TARIF_PERMISSIONS } from "@/features/ventes/config/tarifs/constants";

export const Route = createFileRoute("/_app/ventes/tarifs/promotions/$id/edit")({
  loader: requirePermission(TARIF_PERMISSIONS.PROMOTIONS_EDIT),
  staticData: {
    title: "Modifier promotion",
    showInBreadcrumb: true,
  },
  component: EditPromotionPage,
});
